export default __webpack_public_path__ + "static/media/20-StainedGlassDonut.1b9c66d6.png";